import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpHandler, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { Apollo } from 'apollo-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthSsoInterceptor } from './_helpers/auth-sso.interceptor';
import { AuthLoginGuard } from './_helpers/login-guard.interceptor';
import { PortalGraphQlApiService } from './_services/dx-graphql-api.service';
import { PortalAuthenticationService } from './_services/dx-portal-auth.service';
import { DXComponentModules } from './_shared/dx-components/dx.component.module';
import { PortalMainService } from './_services/dx-portal-main.service';
import { PrimeNgAngularModule } from './_shared/dx-components/_library/primeng/primeng.angular';
import { GraphQlLeadsDownloadComponent } from './dx-apps/leads-main-page/graphql-leads-downloads';
import { PortalAuthGuard } from './_guards/authentication.guard';
import { UnauthorizedComponent } from './security/unauthorized.component';
import { ToastrModule } from 'ngx-toastr';
import { DxToastService } from './_services/dx-notifications.service';
import { LoginForgotComponent } from './login/forgot-password/login.forgot.component';
import { LoginForgotConfirmComponent } from './login/forgot-password/login.forgot.confirm.component';
import { ChangePasswordComponent } from './login/change-password/change-password.component';
import { ChangePasswordSuccessfulComponent } from './login/change-password/change-password.successful.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SSOLoginComponent } from './login/content-sso-login/contenthub-sso-login';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { CmpSyncService } from './dx-apps/campaign-sync-thumb-files/_services/cmp-sync-service';
import { WhitePaperSyncService } from './dx-apps/campaign-sync/services/whitepaper-sync.service';

const theme_sky = definePreset(aura, {
  semantic: {
    primary: {
      50: '{sky.50}',
      100: '{sky.100}',
      200: '{sky.200}',
      300: '{sky.300}',
      400: '{sky.400}',
      500: '{sky.500}',
      600: '{sky.600}',
      700: '{sky.700}',
      800: '{sky.800}',
      900: '{sky.900}',
      950: '{sky.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{sky.500}',
          inverseColor: '#ffffff',
          hoverColor: '{sky.600}',
          activeColor: '{sky.500}',
        },
        highlight: {
          background: '{sky.700}',
          focusBackground: '{sky.600}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '{sky.50}',
          inverseColor: '{sky.700}',
          hoverColor: '{sky.100}',
          activeColor: '{sky.200}',
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
});


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    UnauthorizedComponent,
    GraphQlLeadsDownloadComponent,
    LoginForgotComponent,
    LoginForgotConfirmComponent,
    ChangePasswordComponent,
    ChangePasswordSuccessfulComponent,
    SSOLoginComponent
  ],
  imports: [
    BrowserModule,
    PrimeNgAngularModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    DXComponentModules,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 5000, // 15 seconds
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-top-center',
    }),
    NgbModule,
    
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
        theme: {
            preset: theme_sky
        }
    }),
    PortalAuthenticationService,
    PortalGraphQlApiService,
    PortalMainService,
    PortalAuthGuard,
    DxToastService,
    CmpSyncService,
    WhitePaperSyncService,
    Apollo,
    { provide: HTTP_INTERCEPTORS, useClass: AuthSsoInterceptor, multi: true },
    {
      provide: [APP_INITIALIZER,HttpHandler,HttpClient],
      useFactory: (portal: PortalMainService) => function() {return portal.initApplication();},
      deps: [PortalMainService],
      multi: true
    }
    
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
